import React, { useState, useImperativeHandle, forwardRef } from 'react'
import Button from '@material-ui/core/Button';
import Api from '../../../../__helpers/api'
import { useAuthDataContext } from '../../../../__providers/AuthProvider';

//images
import videoProgressImg from '../../../../assets/images/profile/guide/video-progress.png'

function Video(props, ref) {
    const auth = useAuthDataContext();

    const [guide, setGuide] = useState({
        blur: false,
        popup: false,
    })

    useImperativeHandle(ref, () => ({
        open: () => {
            handleOpen()
        },
        close: () => {
            handleClose()
        }
    }))

    const handleOpen = () => {
        setGuide(guide => ({
            ...guide,
            blur: true,
        }))
        setTimeout(() => {
            setGuide(guide => ({
                ...guide,
                popup: true
            }))
        }, 50);
    }

    const handleClose = () => {
        Api.post('student/hide-video-tutor')
            .then(() => {
                auth.refresh()
            })

        setGuide(guide => ({
            ...guide,
            popup: false
        }))
        setTimeout(() => {
            setGuide(guide => ({
                ...guide,
                blur: false,
            }))
        }, 100);
    }

    return (
        <div id="overlay" className={guide.blur ? 'visible' : ''}>
            <div className={`box guide single-slide-guide ${guide.popup ? 'show' : ''}`}>
                <div className="guide-slider-wrapper">
                    <ul className="guide-slider slide-1">
                        <li className="active">
                            <img src={videoProgressImg} alt="video progress" />
                        </li>
                    </ul>
                </div>

                <ul className="guide-content">
                    <li>
                        <h3>
                            Изгледа {props.percent}% от лекциите на Тема 1
                        </h3>
                        <p>
                            След като изгледаш <b>80% от видео лекциите</b> от Тема1, Авто Обучение ще ти отключи изпитните въпроси от Тема 1.
                        </p>
                    </li>
                </ul>

                <div className="buttons">
                    <div className="row">
                        <Button onClick={handleClose}>
                            Разбрах
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default forwardRef(Video)